export {
  VerifyAccountDetailsFormValues,
  VerifyAccountDetailsFormProps
} from './types';
export { VerifyAccountDetailsForm } from './VerifyAccountDetailsForm';
